// Keep this in lockstep with REPORT_REASONS in server/models/report.js —
// these are the literal enum values the backend accepts as `reason`.
export const REPORT_REASONS = [
  "spam",
  "harassment",
  "hate_speech",
  "explicit",
  "other",
];

// Display text only — the value sent to the API is always the raw id above.
const REASON_LABELS = {
  spam: "Spam",
  harassment: "Harassment",
  hate_speech: "Hate speech",
  explicit: "Explicit content",
  other: "Other",
};

export const getReportReasonLabel = (reasonId) => REASON_LABELS[reasonId] || reasonId;

export const createReport = async ({ target_type, target_id, reason }, apiCall) => {
  try {
    const response = await apiCall('/api/reports/create', {
      method: 'POST',
      body: JSON.stringify({ target_type, target_id, reason }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      const errorMessage = data.message || `Error: ${response.status}`;
      throw new Error(errorMessage);
    }

    return {
      success: true,
      message: data.message,
      data: data.data,
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Create report error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to submit report. Please try again.',
    };
  }
};